import { ServiceResponse } from "../../api/ServiceResponse";
import { PtsAlert } from "./PtsAlert";

export class PtsAlertResponse extends ServiceResponse {
  ptsAlertList?: PtsAlert[];
  count?: number;

  constructor(init?: Partial<PtsAlertResponse>) {
    super(init); // calls ServiceResponse constructor
    Object.assign(this, init);
  }

  // Getters & Setters
  getPtsAlertList(): PtsAlert[] | undefined {
    return this.ptsAlertList;
  }
  setPtsAlertList(value: PtsAlert[] | undefined): void {
    this.ptsAlertList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
